export const DATAGRID_LOCALE_ZHCHS = {
    lineNumberTitle: 'åºå·',
    emptyMessage: 'ææ æ°æ®',
    pagination: {
        previousLabel: 'ä¸ä¸é¡µ',
        nextLabel: 'ä¸ä¸é¡µ',
        message: 'å± <b>{1}</b> æ¡ ',
        pagelist: {
            firstText: 'æ¾ç¤º',
            lastText: 'æ¡'
        },
        previous: 'ä¸ä¸é¡µ',
        next: 'ä¸ä¸é¡µ'
    },
    filter: {
        title: 'è¿æ»¤æ¡ä»¶',
        reset: 'éç½®',
        clear: 'æ¸ç©ºæ¡ä»¶',
        clearAll: 'æ¸ç©ºæææ¡ä»¶',
        setting: 'é«çº§è®¾ç½®',
        nofilter: '[ æ  ]',
        checkAll: 'å¨é',
        and: 'å¹¶ä¸',
        or: 'æè',
        operators: {
            equal: 'ç­äº',
            notEqual: 'ä¸ç­äº',
            greater: 'å¤§äº',
            greaterOrEqual: 'å¤§äºç­äº',
            less: 'å°äº',
            lessOrEqual: 'å°äºç­äº',
            contains: 'åå«',
            notContains: 'ä¸åå«',
            like:  'åå«',
            notLike: 'ä¸åå«',
            in: 'å±äº',
            notIn: 'ä¸å±äº',
            empty: 'ä¸ºç©º',
            notEmpty: 'ä¸ä¸ºç©º',
            null: 'null',
            notNull: 'ä¸ä¸ºnull'
        },
        more: 'æ¥çæ´å¤'
    },
    settings: {
        visible: 'æ¾ç¤ºå',
        sortting: 'åæåº',
        title: 'åéç½®',
        canchoose: 'å¯éå',
        choosed: 'å·²éå',
        asc: 'ååº',
        desc: 'éåº',
        cancelSort: 'åæ¶æåº',
        ok: 'ç¡®å®',
        cancel: 'åæ¶',
        reset: 'æ¢å¤é»è®¤',
        conciseMode: 'ç®æ´æ¨¡å¼',
        advancedMode: 'é«çº§æ¨¡å¼',
        formatSetting: 'åæ ¼å¼',
        properties: 'åå±æ§',
        groupping: 'åç»',
        allColumns: 'ææå',
        visibleColumns: 'å¯è§å',
        hiddenColumns: 'éèå',
        searchPlaceholder: 'è¯·è¾å¥ååç§°',
        checkall: 'å¨é¨æ¾ç¤º/éè',
        headeralign: 'è¡¨å¤´å¯¹é½',
        dataalign: 'æ°æ®å¯¹é½',
        alignLeft: 'å·¦å¯¹é½',
        alignCenter: 'å±ä¸­å¯¹é½',
        alignRight: 'å³å¯¹é½',
        summarytype: 'æ±æ»åè®¡ç±»å',
        summarytext: 'æ±æ»åè®¡ææ¬',
        summaryNone: 'æ ',
        summarySum: 'æ±å',
        summaryMax: 'æå¤§å¼',
        summaryMin: 'æå°å¼',
        summarCount: 'è®¡æ°',
        summaryAverage: 'å¹³åå¼',
        grouppingField: 'åç»å­æ®µ',
        moreGrouppingFieldWarningMessage: 'æå¤è®¾ç½®3ä¸ªå­æ®µè¿è¡åç»',  // Up to 3 fields are set for grouping
        grouppingSummary: 'åç»åè®¡',
        addGrouppingFieldTip: 'æ·»å åç»å­æ®µ',
        removeGrouppingFieldTip: 'ç§»é¤åç»å­æ®µ',
        grouppingSummaryType: 'åç»åè®¡ç±»å',
        grouppingSummaryText: 'åç»åè®¡ææ¬',
        restoreDefaultSettingsText: 'ç¡®è®¤è¦æ¢å¤é»è®¤è®¾ç½®å?',
        simple: {
            title: 'æ¾ç¤ºå',
            tip: 'éä¸­çå­æ®µå¯å±ç¤ºå°åè¡¨ä¸­ï¼ææ½å¯è°æ´å¨åè¡¨ä¸­çå±ç¤ºé¡ºåºã',
            count: 'å·²æ¾ç¤º <span class="visible-cols-count">{0}</span> å'
        }
    },
    selectionData: {
        clearAll: 'æ¸ç©º',
        tooltip: 'ç¹å»æ¾ç¤ºå·²éè®°å½åè¡¨',
        currentLenth: `å·²éæ©ï¼<b>{0}</b> æ¡`
    },
    groupRow: {
        tips: 'æå¨åå°è¿å¿å¯è¿è¡æ°æ®åç»',
        removeColumn: 'ç§»é¤åç»å',
        clearTip: 'æ¸é¤ææåç»å­æ®µ',
        clear: 'æ¸ç©º'
    }
};
